export const achievementData = {
    bio : "These are some of my achievements that I am most proud of !!",
    achievements : [
        {
            id : 1,
            title : 'Geeks for Geeks 11 weeks workshop on DSA',
            details : 'Learned data structures & algorithms in C++. Solved various problems on DSA',
            date : 'Dec 20, 2021',
            field : 'DSA',
            image : 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667626223/gfg_can7vy.png'
        },
        {
            id : 2,
            title : 'TA Excellence Award at Crio.Do',
            details : 'Received TA excellence award from Crio.Do for best performance in resolving doubts on DSA',
            date : 'Sep 10, 2022',
            field : 'DSA',
            image : 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667627571/crio_yeqccs.png'
        },
        {
            id : 3,
            title : 'AWS Machine learning scholarship challenge',
            details : "Completed the AWS Machine Learning Foundations course in the AWS Machine Learning Scholarship",
            date : 'Oct 22, 2021',
            field : 'Machine Learning',
            image : 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667627850/udac_ebgozk.png'
        },
        {
            id : 4,
            title : 'Udemy Web Developer Certification',
            details : 'Completed the web developer bootcamp of MERN stack and designed a robust web application.',
            date : 'May 28, 2021',
            field : 'Web Development',
            image : 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667627738/web_x31q1z.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/